import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import ShareSocials from "core/ShareSocials";

import Flexbox from "core/Flexbox";
import colors from "core/colors";
import { TextWrapper, Wrapper } from "./styles";

import { PHOTO_DETAIL } from "data/links";

const UnwrappedMessageBanner = ({
    className,
    showSocialLinks,
    accentColor,
    icon,
    iconTitle,
    photo,
    children
}) => {
    const Icon = icon;

    return (
        <Wrapper className={className} accentColor={accentColor}>
            <Flexbox alignItems="center" justifyContent="space-between">
                <Flexbox alignItems="center">
                    {/* 'size' and 'fillColor' props are used
                    to style "styled-svg" components only */}
                    <Icon
                        title={iconTitle}
                        size={{ width: 21, height: 21 }}
                        fillColor={accentColor}
                    />
                    <TextWrapper>{children}</TextWrapper>
                </Flexbox>
                {showSocialLinks && (
                    <ShareSocials
                        spaceBetweenIcons="0.8125rem"
                        creatorName={photo.creator.name}
                        imageType="photo"
                        // TODO: Replace with permalink from backend when that gets implemented
                        permalinkPath={PHOTO_DETAIL.replace(
                            ":photoSlugWithId",
                            photo.slugWithId
                        )}
                        socialIconHeight={24}
                        socialIconWidth={24}
                        socialIconColor={colors.mist}
                    />
                )}
            </Flexbox>
        </Wrapper>
    );
};

UnwrappedMessageBanner.propTypes = {
    className: PropTypes.string,
    children: PropTypes.any,
    showSocialLinks: PropTypes.bool,
    accentColor: PropTypes.string,
    photo: PropTypes.object,
    iconTitle: PropTypes.string,
    // pass React component, like an SVG styled-component
    icon: PropTypes.oneOfType([PropTypes.object, PropTypes.func]).isRequired
};

const MessageBanner = styled(UnwrappedMessageBanner)``;

export default MessageBanner;
